import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Smartphone, Search, MessageCircle, Server, Globe, FormInput, MapPin, Gauge, Sparkles, HeadphonesIcon, TrendingUp } from 'lucide-react';
import { revealVariants, staggerContainer, itemVariants } from '../utils/animations';
const benefits = [{
  icon: Zap,
  title: 'Web premium en 72hs',
  desc: 'Lanzamiento ultra rápido sin perder calidad.'
}, {
  icon: Smartphone,
  title: 'Responsive design',
  desc: 'Se ve perfecta en cualquier dispositivo móvil.'
}, {
  icon: Search,
  title: 'SEO básico',
  desc: 'Estructura optimizada para Google.'
}, {
  icon: MessageCircle,
  title: 'WhatsApp integrado',
  desc: 'Chat directo para cerrar más ventas.'
}, {
  icon: Server,
  title: 'Hosting incluido',
  desc: 'Servidores rápidos y seguros por 1 año.'
}, {
  icon: Globe,
  title: 'Dominio personalizado',
  desc: 'Tu marca profesional (.com o .com.ar).'
}, {
  icon: FormInput,
  title: 'Formularios inteligentes',
  desc: 'Captura de leads automatizada.'
}, {
  icon: MapPin,
  title: 'Google Maps',
  desc: 'Facilitá que tus clientes te encuentren.'
}, {
  icon: Gauge,
  title: 'Optimización de velocidad',
  desc: 'Carga instantánea para no perder visitas.'
}, {
  icon: Sparkles,
  title: 'Diseño AI-style',
  desc: 'Estética moderna de Silicon Valley.'
}, {
  icon: HeadphonesIcon,
  title: 'Soporte técnico',
  desc: 'Gratis por 1 año.'
}, {
  icon: TrendingUp,
  title: 'Conversión optimizada',
  desc: 'Diseño enfocado en generar clientes.'
}];
export function BenefitsSection() {
  return <section id="beneficios" className="py-20 md:py-32 relative" data-id="element-23">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-24">
        <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-20" data-id="element-25">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter text-white mb-6" data-id="element-26">
            Todo lo que necesitás para <br className="hidden md:block" data-id="element-27" /> verte
            premium online.
          </h2>
        </motion.div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-28">
          {benefits.map((benefit, idx) => <motion.div key={idx} variants={itemVariants} className="group relative p-6 rounded-2xl bg-white/[0.02] border border-white/5 hover:bg-white/[0.04] transition-all duration-300 overflow-hidden" data-id="element-29">
              <div className="absolute inset-0 bg-gradient-to-r from-electric via-neon to-cyan opacity-0 group-hover:opacity-20 transition-opacity duration-500" style={{
            padding: '1px',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude'
          }} data-id="element-30"></div>

              <div className="relative z-10" data-id="element-31">
                <benefit.icon size={24} className="text-neon mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-32" />
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-33">
                  {benefit.title}
                </h3>
                <p className="text-sm text-neutral-400 leading-relaxed" data-id="element-34">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}